import { c as _c } from "react/compiler-runtime";
import { useCopilot } from 'shared/context/CopilotContext';
import { useCopilotDrawerKeyboardShortcuts } from 'shared/copilot/hooks/useCopilotDrawerKeyboardShortcuts';

/**
 * Global keybindings for the dashboard chrome (side nav + top nav).
 *
 * Page-specific shortcuts should live in their own page-level hooks so
 * bindings stay easy to find and do not collide across unrelated UI groups.
 */
export const useDashboardFrameKeybindings = () => {
  const $ = _c(5);
  const {
    isCopilotSidenavEnabled,
    openCopilotDrawer,
    toggleCopilot,
    createNewChat
  } = useCopilot();
  let t0;
  if ($[0] !== createNewChat || $[1] !== isCopilotSidenavEnabled || $[2] !== openCopilotDrawer || $[3] !== toggleCopilot) {
    t0 = {
      openCopilotDrawer,
      toggleCopilot,
      createNewChat,
      enabled: isCopilotSidenavEnabled
    };
    $[0] = createNewChat;
    $[1] = isCopilotSidenavEnabled;
    $[2] = openCopilotDrawer;
    $[3] = toggleCopilot;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  useCopilotDrawerKeyboardShortcuts(t0);
};